import React, { useState } from "react";
import { FaTimes, FaBook, FaEnvelope, FaComments, FaLightbulb } from "react-icons/fa";
import ChatWidget from "./ChatWidget"; // Assurez-vous que le chemin est correct

function SupportPopup({ isOpen, onClose }) {
  const [showChat, setShowChat] = useState(false);

  // Basculer l'affichage du widget de chat sans fermer le pop-up d'aide
  const toggleChatWidget = () => {
    setShowChat(!showChat);
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed bottom-4 left-[14rem] w-80 bg-white text-black shadow-md rounded p-4 z-[9999] border border-gray-200">
        {/* Header du popup */}
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-lg font-bold">Besoin d’aide&nbsp;?</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
            aria-label="Fermer"
          >
            <FaTimes />
          </button>
        </div>
        {/* Sous-titre ou description */}
        <p className="text-sm text-gray-600 mb-4">
          Trouvez des réponses rapides ou contactez notre équipe de support.
        </p>
        {/* Liste d'actions / liens */}
        <ul className="space-y-3">
          <li className="flex items-center space-x-2">
            <FaBook className="text-green-600" />
            <a
              href="https://www.aigenz.com/faq"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-green-700 hover:underline"
            >
              Consulter la FAQ
            </a>
          </li>
          <li className="flex items-center space-x-2">
            <FaEnvelope className="text-green-600" />
            <a
              href="mailto:support@aigenz.com"
              className="text-sm text-green-700 hover:underline"
            >
              Contacter le support
            </a>
          </li>
          <li className="flex items-center space-x-2">
            <FaComments className="text-green-600" />
            <button
              onClick={toggleChatWidget}
              className="text-sm text-green-700 hover:underline"
            >
              Ouvrir le chat
            </button>
          </li>
          <li className="flex items-center space-x-2">
            <FaLightbulb className="text-green-600" />
            <button
              onClick={() => alert("Formulaire de feedback (non implémenté).")}
              className="text-sm text-green-700 hover:underline"
            >
              Donner mon avis
            </button>
          </li>
        </ul>
      </div>

      {/* Chat widget modal */}
      {showChat && (
        <div className="fixed bottom-4 right-4 w-80 h-96 bg-white shadow-lg rounded p-4 z-[10000] border border-gray-200">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-lg font-bold">Chat AIGENZ</h3>
            <button
              onClick={toggleChatWidget}
              className="text-gray-500 hover:text-gray-700"
              aria-label="Fermer"
            >
              <FaTimes />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto border p-2">
            <p className="text-sm text-gray-700">Bienvenue dans notre chat !</p>
            {/* Intégrez ici la logique d'affichage des messages */}
          </div>
          <div className="mt-2">
            <input
              type="text"
              placeholder="Tapez votre message..."
              className="w-full border border-gray-300 rounded px-2 py-1"
            />
          </div>
        </div>
      )}
    </>
  );
}

export default SupportPopup;